import React, { Suspense } from 'react';
import * as index from '../../icons/index.js';

const Icon = ({ customIcon = null, iconName, ...props }) => {
  if (iconName) {
    const Component = index[iconName];
    if (!Component) return /* @__PURE__ */ React.createElement("span", { style: { color: "red" } }, "Icon not found");
    if (Component) {
      return /* @__PURE__ */ React.createElement(Suspense, { fallback: null }, /* @__PURE__ */ React.createElement(Component, { ...props }));
    }
    return iconName;
  }
  if (typeof customIcon === "string") {
    const Component = index[customIcon];
    if (Component) {
      return /* @__PURE__ */ React.createElement(Suspense, { fallback: null }, /* @__PURE__ */ React.createElement(Component, { ...props }));
    }
    return /* @__PURE__ */ React.createElement("img", { src: customIcon, alt: customIcon, ...props });
  }
  return customIcon;
};
Icon.displayName = "Icon";

export { Icon };
//# sourceMappingURL=index.js.map
